import { ComponentProps } from 'react';
import classNames from 'classnames';
import Button from 'components/gruenland/atoms/button/Button';
import { useFormat } from 'helpers/hooks/useFormat';

export interface SaveOrCancelProps extends ComponentProps<'div'> {
  variant?: 'save' | 'delete';
  loading?: boolean;
  onSave?: (e: React.FormEvent) => void;
  onCancel: () => void;
}

const SaveOrCancel: React.FC<SaveOrCancelProps> = ({ variant = 'save', loading, className, onSave, onCancel }) => {
  const { formatMessage } = useFormat({ name: 'gruenland' });

  const containerClassName = classNames('flex gap-3', className);

  return (
    <div className={containerClassName}>
      <Button
        type="button"
        variant="buttonSecondary"
        className="flex h-10 w-[112px] items-center justify-center p-0 text-[14px]"
        onClick={onCancel}
      >
        {formatMessage({ id: 'common.cancel', defaultMessage: 'Annulla' })}
      </Button>

      {variant == 'save' ? (
        <Button loading={loading} type="submit" className="h-10 w-[112px] p-0 text-[14px]" onClick={onSave}>
          {formatMessage({ id: 'common.save', defaultMessage: 'Salva' })}
        </Button>
      ) : (
        <Button
          loading={loading}
          variant="warning"
          type="submit"
          className="h-10 w-[112px] px-0 text-[14px]"
          onClick={onSave}
        >
          {formatMessage({ id: 'common.delete', defaultMessage: 'Elimina' })}
        </Button>
      )}
    </div>
  );
};

export default SaveOrCancel;
